var _style, _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNonProctoredCertExamIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "8 23.5 85 65",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#00263D;}\r\n\t.st1{fill:#3FBFAD;}\r\n\t.st2{fill:none;stroke:#00263D;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st3{fill:none;stroke:#00263D;stroke-width:0.8611;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n    ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.4,85.9H11.6c-0.6,0-1-0.4-1-1V27c0-0.6,0.4-1,1-1h77.8c0.6,0,1,0.4,1,1v57.9C90.4,85.5,90,85.9,89.4,85.9z M12.6,83.9h75.8V28H12.6V83.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M83.4,79.5H17.7c-0.4,0-0.8-0.3-0.8-0.8V33.1c0-0.4,0.3-0.8,0.8-0.8h65.7c0.4,0,0.8,0.3,0.8,0.8v45.7 C84.2,79.2,83.8,79.5,83.4,79.5z M18.5,78h64.2V33.9H18.5V78z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 28.6,
    y1: 46.5,
    x2: 72.5,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 28.6,
    y1: 55.4,
    x2: 61.1,
    y2: 55.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 28.6,
    y1: 60.4,
    x2: 61.1,
    y2: 60.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 28.6,
    y1: 65.3,
    x2: 61.1,
    y2: 65.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonProctoredCertExamIcon);
export default __webpack_public_path__ + "static/media/non-proctored-cert-exam-icon.077b5a1a04e7930803368a5f9c1fe240.svg";
export { ForwardRef as ReactComponent };